// Curated, verified official websites for the most common affordable-housing
// developers in the CTCAC pipeline. The CTCAC dataset has no website field, so
// known developers link straight to their site; everyone else falls back to a
// Google search of the builder name (so we never link to the wrong company).
//
// Keys are lowercased developer names exactly as they appear in the dataset.
const BUILDER_SITES = {
    'pacific west communities, inc.': 'https://pacificwestcompanies.com/',
    'eden housing, inc.': 'https://edenhousing.org/',
    'national community renaissance of california': 'https://nationalcore.org/',
    'chelsea investment corporation': 'https://www.chelseainvestco.com/',
    'affirmed housing group, inc.': 'https://affirmedhousing.com/',
    'midpen housing corporation': 'https://www.midpen-housing.org/',
    'wakeland housing and development corporation': 'https://www.wakelandhdc.com/',
    'mercy housing california': 'https://www.mercyhousing.org/california/',
};

/**
 * Returns { url, direct } for a builder name.
 *  - direct: true  -> verified official website
 *  - direct: false -> Google search fallback for the builder name
 */
export function builderLink(name) {
    if (!name) return null;
    const key = name.trim().toLowerCase();
    if (BUILDER_SITES[key]) return { url: BUILDER_SITES[key], direct: true };
    return {
        url: `https://www.google.com/search?q=${encodeURIComponent(`${name} affordable housing developer`)}`,
        direct: false,
    };
}

export default BUILDER_SITES;
